var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useState } from 'react';
import { useMediaQueries } from '@honda-canada/design-system-react';
import Context from './Context';
import safelyStringifyJSON from '../../../utils/safelyStringifyJSON';
import { useConfiguration } from './utils';
export var TrimPackagesModalType;
(function (TrimPackagesModalType) {
    TrimPackagesModalType["BUY_NOW_MODAL"] = "BUY_NOW_MODAL";
})(TrimPackagesModalType || (TrimPackagesModalType = {}));
var ConfigurationProvider = function (_a) {
    var children = _a.children, variant = _a.variant, vehicleType = _a.vehicleType, categoryName = _a.categoryName, appNameConfig = _a.appNameConfig;
    var config = useConfiguration(variant);
    var _b = useState(0), currentSlide = _b[0], setCurrentSlide = _b[1];
    var _c = useState(5), slidePerPage = _c[0], setSlidePerPage = _c[1];
    var _d = useState(), selectedTrim = _d[0], setSelectedTrim = _d[1];
    var _e = useState(null), modal = _e[0], setModal = _e[1];
    var _f = useMediaQueries(), isSmallDesktop = _f.isSmallDesktop, isDesktop = _f.isDesktop;
    var isMobile = !(isSmallDesktop || isDesktop);
    var perPage = isMobile ? 1 : slidePerPage;
    var splideOptions = {
        perPage: perPage,
        pagination: false,
        arrows: false,
        start: currentSlide,
    };
    var contextValue = useMemo(function () { return (__assign(__assign(__assign({ variant: variant, vehicleType: vehicleType, categoryName: categoryName }, config), appNameConfig), { slidePerPage: slidePerPage, setSlidePerPage: setSlidePerPage, selectedTrim: selectedTrim, setSelectedTrim: setSelectedTrim, currentSlide: currentSlide, setCurrentSlide: setCurrentSlide, splideOptions: splideOptions, isMobile: isMobile, modal: modal, setModal: setModal })); }, [
        variant,
        vehicleType,
        categoryName,
        slidePerPage,
        selectedTrim,
        currentSlide,
        perPage,
        isMobile,
        modal,
        setModal,
        safelyStringifyJSON(config),
        safelyStringifyJSON(appNameConfig),
    ]);
    return React.createElement(Context.Provider, { value: contextValue }, children);
};
export default ConfigurationProvider;
